import SpotGuidePageContainer from './SpotGuidePageContainer';

export default SpotGuidePageContainer;
